import {storeFromArea} from "./../../utils";
import * as PagingActions from "./../paging/PagingActions"

export const REQUEST = 'list.simple.request'
export const RESPONSE = 'list.simple.response'
export const FILTER = 'list.simple.filter'
export const INVALIDATE = 'list.simple.invalidate'
export const SELECT_PARENT = 'list.simple.selectParent'

/**
 * Zneplatnění dat.
 * @param area oblast
 */
export function invalidate(area, data) {
    return {
        type: INVALIDATE,
        area,
    }
}

/**
 * Filtrování položek seznamu.
 * @param area oblast
 * @param filter filtr
 * @returns {{type: string, area: *, filter: *}}
 */
export function filter(area, filter) {
    return {
        type: FILTER,
        area,
        filter,
    }
}

/**
 * Načtení dat pokud je potřeba.
 * @param area oblast
 * @param parent parent data pro seznam, pokud je potřeba, např. id nadřazené entity, ke které se vztahuje seznam
 * @param getData promise pro načtení
 * @param forceFetch pokud je true, provede se vždy nové načtení
 */
export function fetchIfNeeded(area, parent, getData, forceFetch = false) {
    return (dispatch, getState) => {

        // Spočtení data key
        var store = storeFromArea(getState(), area);

        // Pokud ve store není potřebný parent, dáme ho tam, aby se nám správně spočetl data key
        if (store.parent !== parent) {
            dispatch(selectParent(area, parent));
            store = storeFromArea(getState(), area);
        }

        const dataKey = store.getDataKey.bind(store)();
        if (forceFetch || store.currentDataKey !== dataKey) {
            dispatch(request(area, dataKey));

            // Vstupní data pro request dat
            const storeForRequest = storeFromArea(getState(), area);
            const filter = storeForRequest.filter;
            let pagingInfo;
            if (storeForRequest.supportPaging) {
                pagingInfo = {
                    pageIndex: storeForRequest.paging.pageIndex,
                    pageSize: storeForRequest.paging.pageSize
                }
            }

            getData(parent, filter, pagingInfo)
                .then(json => {
                    const newStore = storeFromArea(getState(), area);
                    const newDataKey = newStore.getDataKey.bind(newStore)();
                    if (newDataKey === dataKey) {   // jen pokud přídchozí objekt odpovídá datům, které chceme ve store

                        // Upravení stránkování
                        dispatch(PagingActions.setItemsCount(area, json.count));

                        // Načtená data
                        if (json && json.rows) {
                            dispatch(response(area, json.rows, json.count))
                        } else if (json) {
                            dispatch(response(area, json, 0))
                        }
                    }
                })  // TODO [stanekpa] - řešit catch a vrácení datakey!
                .catch(error => {
                    // dispatch(invalidate(area))   // zatím ne, protože se to poté opakuje pořád dokola, nutné řešit opakování s prodlevou a po několika neúspěšných pokusem ukončit
                })
        }
    }
}

/**
 * Test, předaná akce je akcí pro tuto třídu.
 * @param action akce
 * @returns {boolean} true, pokud action odpovídá této třídě
 */
export function is(action) {
    // Stránkování
    if (PagingActions.is(action)) {
        return true;
    }

    // Vlastní akce
    switch (action.type) {
        case FILTER:
        case REQUEST:
        case RESPONSE:
        case INVALIDATE:
            return true;
        default:
            return false;
    }
}

/**
 * Výběr nového parenta, volá se i v případě, že je zavoláno fetchIfNeeded s jiným parent něž ve store.
 * @param area oblast
 * @param id id
 * @returns {{type: string, area: *, id: *}}
 */
function selectParent(area, parent) {
    return {
        type: SELECT_PARENT,
        area,
        parent,
    }
}

/**
 * Request dat.
 * @param area oblast
 * @param dataKey data key
 * @returns {{type: string, area: *, dataKey: *}}
 */
function request(area, dataKey) {
    return {
        type: REQUEST,
        area,
        dataKey,
    }
}

/**
 * Response dat.
 * @param area oblast
 * @param rows řádky
 * @param count celkový počet řádek, např. v db pro daný filter
 * @returns {{type: string, area: *, data: *}}
 */
function response(area, rows, count) {
    return {
        type: RESPONSE,
        area,
        rows,
        count
    }
}

